<header (scroll)="onWindowScroll($event);">

    <!--begin navbar-fixed-top -->
    <nav class="navbar navbar-expand-lg navbar-default navbar-fixed-top {{addlClass}} "
        style="position: fixed !important;max-width: 100vw;" id="navbarMain" [class.sticky]="sticky">

        <!-- <div *ngIf="addlClass == 'header-default'" class="default-header-waves">
        <img src="./assets/images/default-header-waves.svg">
    </div> -->

        <!--begin container -->
        <div class="container animated fadeInDown col-md-9">

            <!--begin logo -->
            <a class="navbar-brand" routerLink="/" style="margin-left: -10px;">
                <img *ngIf="addlClass != 'header-default' && !sticky"
                    [attr.style]="isMobile ? 'height: 60px;padding-left: 10px;':'height: 60px;'"
                    src="./assets/images/SingX_w_logo.webp" alt="SingX Logo - Cross Border Payments" id="logo">
                <img *ngIf="addlClass == 'header-default' || sticky"
                    [attr.style]="isMobile ? 'height: 60px;padding-left: 10px;':'height: 60px;'"
                    src="./assets/images/SingX_logo.webp" alt="SingX Logo - Cross Border Payments" id="logo">
                <img style="height: 50px;" src="./assets/images/SingX_w_logo.webp"
                    alt="SingX Logo - Cross Border Payments" id="logo_w" style="display: none;"></a>
            <!--end logo -->
            <!-- For SG -->
            <ul class="ml-3 nav navbar-nav navbar-nav--tabs navbar-switch" *ngIf="country == 'sg'">
                <li class="navbar-item dropdown">
                    <a id="dropdownMenuLink" class="btn text-ellipsis btn-active btn-link btn-tab dropdown-toggle"
                        data-toggle="dropdown" title="Personal">Personal</a>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <li><a class="dropdown-item" routerLink="/" [routerLinkActiveOptions]="{exact:true}">Overseas Money Transfer</a></li>
                        <li><a class="dropdown-item" routerLink="/country-details">Country Coverage</a></li>
                        <li><a class="dropdown-item" routerLink="/wallet" rel="noreferrer">Other Services</a></li>
                    </ul>
                </li>
                <li class="navbar-btn navbar-divider" id="menuLi4" aria-hidden="true">&nbsp;</li>
                <li class="navbar-btn"><a id="menuLi5" href="https://business.singx.co"
                        class="btn text-ellipsis btn-link btn-tab" title="Business" rel="noreferrer">Business</a></li>
            </ul>
            <!-- End SG -->
            <!-- For HK -->
            <ul class="ml-3 nav navbar-nav navbar-nav--tabs navbar-switch" *ngIf="country == 'hk'">
                <li class="navbar-item dropdown">
                    <a id="dropdownMenuLink" routerLink="/" class="btn text-ellipsis btn-active btn-link btn-tab"
                        data-toggle="dropdown" title="Personal" style="text-decoration: none;">Personal</a>
                </li>
                <li class="navbar-btn navbar-divider" id="menuLi4" aria-hidden="true">&nbsp;</li>
                <li class="navbar-btn"><a id="menuLi5" href="https://business.singx.co"
                        class="btn text-ellipsis btn-link btn-tab" title="Business" rel="noreferrer">Business</a></li>
            </ul>
            <!-- End HK -->

            <!-- au header -->
            <ul class="ml-3 nav navbar-nav navbar-nav--tabs navbar-switch" *ngIf="country == 'au'">
                <li class="navbar-item dropdown">
                    <a id="dropdownMenuLink" routerLink="/" class="btn text-ellipsis btn-active btn-link btn-tab"
                        data-toggle="dropdown" title="Personal" style="text-decoration: none;">Personal</a>
                </li>
                <li class="navbar-btn navbar-divider" id="menuLi4" aria-hidden="true">&nbsp;</li>
                <li class="navbar-btn"><a id="menuLi5" href="https://business.singx.co"
                        class="btn text-ellipsis btn-link btn-tab" title="Business" rel="noreferrer">Business</a></li>
            </ul>
            <!-- au header end -->

            <!--begin navbar-toggler -->
            <button class="navbar-toggler" type="button" style="background-color: #ff6600;"
                (click)="openDrawer = !openDrawer">
                <span class="navbar-toggler-icon"><i class="fas fa-bars"></i></span>
            </button>
            <!--end navbar-toggler -->

            <!--begin navbar-collapse -->
            <div class="navbar-collapse collapse" id="navbarCollapse" style="margin-right: -20px;">

                <!--begin navbar-nav -->
                <ul class="navbar-nav ml-auto" *ngIf="country">
                    <li>
                        <a><img style="width: 30px;border-radius: 1rem;box-shadow: 0 0 6px 3px rgb(95 95 95 / 16%);"
                                nz-dropdown [nzDropdownMenu]="menu"
                                src="https://singxco.github.io/static-data/images/flags/1x1/{{country}}.svg"
                                alt="{{country.toUpperCase()}}"></a>
                        <nz-dropdown-menu #menu="nzDropdownMenu">
                            <ul nz-menu nzSelectable>
                                <li nz-menu-item (click)="switchCountry('sg')" [nzDisabled]="country == 'sg'">
                                    <img style="width: 20px;border-radius: 1rem; margin-right: 5px;"
                                        src="https://singxco.github.io/static-data/images/flags/1x1/sg.svg" alt="SG">
                                    Singapore
                                </li>
                                <li nz-menu-item (click)="switchCountry('hk')" [nzDisabled]="country == 'hk'">
                                    <img style="width: 20px;border-radius: 1rem; margin-right: 5px;"
                                        src="https://singxco.github.io/static-data/images/flags/1x1/hk.svg" alt="HK">
                                    Hong Kong
                                </li>
                                <li nz-menu-item (click)="switchCountry('au')" [nzDisabled]="country == 'au'">
                                    <img style="width: 20px;border-radius: 1rem; margin-right: 5px;"
                                        src="https://singxco.github.io/static-data/images/flags/1x1/au.svg" alt="AU">
                                    Australia
                                </li>
                            </ul>
                        </nz-dropdown-menu>
                    </li>
                    <li>
                        <a (click)="redirectToLoginPage()" class="discover-btn">Login</a>
                    </li>
                    <li class="discover-link"><a (click)="redirectToRegistrationPage()" class="discover-btn">Sign
                            Up</a>
                    </li>
                </ul>
                <!--end navbar-nav -->

            </div>
            <!--end navbar-collapse -->

        </div>
        <!--end container -->

    </nav>
    <!--end navbar-fixed-top -->

    <nz-drawer [nzClosable]="false" [nzVisible]="openDrawer" nzPlacement="left" (nzOnClose)="openDrawer = !openDrawer">
        <ng-container *nzDrawerContent>
            <ul nz-menu nzMode="inline">
                <li nz-submenu nzTitle="Personal" *ngIf="country == 'sg'">
                    <ul>
                        <li nz-menu-item><a rel="noopener noreferrer" routerLink="/">Overseas Money Transfer</a></li>
                        <li nz-menu-item><a rel="noopener noreferrer" routerLink="/country-details">Country Coverage</a></li>
                        <li nz-menu-item><a rel="noopener noreferrer" routerLink="/wallet" rel="noreferrer">Other
                                Services</a></li>
                    </ul>
                </li>
                <!-- <li nz-menu-item nzDisabled>Business</li> -->
                <li nz-menu-item><a href="https://business.singx.co">Business</a></li>
                <li nz-menu-item nzTitle="Login"><a (click)="redirectToLoginPage()"
                        class="discover-btn onHover">Login</a>
                </li>
                <li nz-menu-item nzTitle="Sign Up"><a (click)="redirectToRegistrationPage()"
                        class="discover-btn onHover">Sign Up</a></li>
                <!-- end au -->
            </ul>
        </ng-container>
    </nz-drawer>
</header>
<div *ngIf="switcher?.show"
    class="ant-notification-notice ant-notification-notice-closable  ng-trigger ng-trigger-notificationMotion countryNotification"
    ng-reflect-ng-class="countryNotification" style="opacity: 1; transform: translateX(0px);">
    <div class="ant-notification-notice-content">
        <div class="ant-notification-notice-content ">
            <div class="">
                <div class="ant-notification-notice-message ">You are currently at SingX {{switcher.actual}}</div>
                <div class="ant-notification-notice-description ">Switch to SingX <a
                        href="/{{switcher.gotoCode}}">{{switcher.detected}}</a>
                </div>
            </div>
        </div>
    </div><a tabindex="0" class="ant-notification-notice-close" (click)="switcher.show = false"><span
            class="ant-notification-notice-close-x"><i class="fa fa-close"></i>
        </span></a>
</div>